import { FC } from 'react';
import { styled, Typography } from '@mui/material';

const ROW_GRID_COLUMNS = '220px 220px 220px minmax(140px,1fr) minmax(140px,1fr) minmax(140px,1fr) 48px';

const IncrementalLaunchDetailsHeader: FC = () => {
  return (
    <StyledHeaderRow>
      <StyledHeaderText align="left">Launch Type</StyledHeaderText>
      <StyledHeaderText align="left">Applied titles</StyledHeaderText>
      <StyledHeaderText align="left">Release Date</StyledHeaderText>
      <StyledHeaderText align="center">Territories</StyledHeaderText>
      <StyledHeaderText align="center">Audio</StyledHeaderText>
      <StyledHeaderText align="center">Timed Text</StyledHeaderText>
      <StyledHeaderText align="center">Actions</StyledHeaderText>
      <div />
    </StyledHeaderRow>
  );
};

export default IncrementalLaunchDetailsHeader;

const StyledHeaderRow = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: ROW_GRID_COLUMNS,
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 7),
  marginTop: theme.spacing(1.5)
}));

const StyledHeaderText = styled(Typography)<{ align?: 'left' | 'center' }>(({ theme, align = 'left' }) => ({
  fontSize: 12,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  color: theme.palette.text.secondary,
  textAlign: align
}));
